import { Base } from './_base';
import { merge_by_template } from '@shared/helpers/collections';
import get from 'lodash-es/get';
import pickBy from 'lodash-es/pickBy';
import isNull from 'lodash-es/isNull';
import { MenuBackend } from '@pbx/models/worksheet-actions/backend/menu';

export class MenuFrontend extends Base {
  constructor(item) {
    super(item);    
    const asterisk_sign = get(this.data, 'options.asterisk_sign', null);
    const sharp_sign = get(this.data, 'options.sharp_sign', null);

    this.data = merge_by_template(this.data, {
      params: {
        wrong: [],
        media: [],
        timeout: 10,
        asterisk_sign: asterisk_sign,
        sharp_sign: sharp_sign
      },
      options: {
        key_0: null,
        key_1: null,
        key_2: null,
        key_3: null,
        key_4: null,
        key_5: null,
        key_6: null,
        key_7: null,
        key_8: null,
        key_9: null,
        timeout: null
      }
    });
  }

  toBackend() {
    const item = this.toBaseBackend();
    const { data } = item;
    let { params, options } = data;
    const { asterisk_sign, sharp_sign, ...other_params } = params;

    options = pickBy(
      {
        ...options,
        asterisk_sign,
        sharp_sign
      },
      val => !isNull(val)
    );

    return new MenuBackend({
      ...item,
      data: {
        params: other_params,
        options: options
      }
    });
  }
}
